import React, { Component } from 'react';
import { Table, Divider, Button, Icon, Popconfirm} from 'antd';
import axios from 'axios';
import LeavePolicyDialogForm from './LeavePolicyForm';
import { connect } from 'react-redux';

const API_HOST_URL = process.env.REACT_APP_API_URL

class LeavePolicy extends Component{
  
  state = {
    datalist: [],
    leavePolicy: {},
    visible: false,
    requestType: ''
  }

  componentDidMount(){
    this.fetchData();
  }

  columns = [
    {
      title: 'LeaveType',
      dataIndex: 'leaveType.leaveType',
      key: 'leaveType'
    },
    {
      title: 'Policy Name',
      dataIndex: 'policyName',
      key: 'policyName'
    },
    // {
    //   title: 'Carry Over Day',
    //   dataIndex: 'carryOverDay',
    //   key: 'carryOverDay'
    // },
    // {
    //   title: 'After Hire Start Period',
    //   dataIndex: 'afterHireStartPeriod',
    //   key: 'afterHireStartPeriod'
    // },
    {
      title: 'Leave Days',
      dataIndex: 'accrualAmount',
      key: 'accrualAmount'
    },
    // {
    //   title: 'Accrual Frequency',
    //   dataIndex: 'accrualFrequency',
    //   key: 'accrualFrequency'
    // },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (record) => (
        <span>
        <a href="javascript:;" onClick={() => this.handleEdit(record)}><Icon type="edit" /></a>

        <Divider type="vertical" />

        {this.state.datalist.length >= 1
          ? (
            <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(record)}>
              <a href="javascript:;"><Icon type="delete" /></a>
            </Popconfirm>
          ) : null}
          </span>
      ),

    }
  ];

  fetchData = () => {
    axios.get(`${API_HOST_URL}/api/leave/leavepolicy/?expand=leaveType`)
      .then(res => {
        this.setState({
          datalist: res.data
        })
      })
  }

  handleCreate = () => {
    const form = this.formRef.props.form;
    const requestType = this.state.requestType;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      switch( requestType ){
        case 'post':
            return axios.post(`${API_HOST_URL}/api/leave/leavepolicy/`, {
              policyName: values.policyName,
              carryOverDay: values.carryOverDay,
              carryOverMonth: values.carryOverMonth,
              afterHireStartPeriod: values.afterHireStartPeriod,
              afterHireStartPeriodType: values.afterHireStartPeriodType,
              accrualAmount: values.accrualAmount,
              accrualFrequency: values.accrualFrequency,
              accrualFrequencyWeeklyDay: values.accrualFrequencyWeeklyDay,
              accrualFrequencyTwiceAMonthDay1: values.accrualFrequencyTwiceAMonthDay1,
              accrualFrequencyTwiceAMonthDay2: values.accrualFrequencyTwiceAMonthDay2,
              accrualFrequencyMonthlyDay: values.accrualFrequencyMonthlyDay,
              accrualFrequencyTwiceAYearDay1: values.accrualFrequencyTwiceAYearDay1,
              accrualFrequencyTwiceAYearMonth1: values.accrualFrequencyTwiceAYearMonth1,
              accrualFrequencyTwiceAYearDay2: values.accrualFrequencyTwiceAYearDay2,
              accrualFrequencyTwiceAYearMonth2: values.accrualFrequencyTwiceAYearMonth2,
              accrualFrequencyQuarterlyDay1: values.accrualFrequencyQuarterlyDay1,
              accrualFrequencyQuarterlyMonth1: values.accrualFrequencyQuarterlyMonth1,
              accrualFrequencyQuarterlyDay2: values.accrualFrequencyQuarterlyDay2,
              accrualFrequencyQuarterlyMonth2: values.accrualFrequencyQuarterlyMonth2,
              accrualFrequencyQuarterlyDay3: values.accrualFrequencyQuarterlyDay3,
              accrualFrequencyQuarterlyMonth3: values.accrualFrequencyQuarterlyMonth3,
              accrualFrequencyQuarterlyDay4: values.accrualFrequencyQuarterlyDay4,
              accrualFrequencyQuarterlyMonth4: values.accrualFrequencyQuarterlyMonth4,
              accrualFrequencyYearlyDay: values.accrualFrequencyYearlyDay,
              accrualFrequencyYearlyMonth: values.accrualFrequencyYearlyMonth,
              maximumAccrual: values.maximumAccrual,
              carryOverAmount: values.carryOverAmount,
              leaveType: values.leaveType 
            })
            .then(res => {
              console.log(res)
              form.resetFields();
              this.setState({ visible: false });
              this.fetchData()
        })
            .catch(error => console.err(error));

        case 'put':
            return axios.put(`${API_HOST_URL}/api/leave/leavepolicy/${this.state.leavePolicy.id}/`, {
              policyName: values.policyName,
              carryOverDay: values.carryOverDay,
              carryOverMonth: values.carryOverMonth,
              afterHireStartPeriod: values.afterHireStartPeriod,
              afterHireStartPeriodType: values.afterHireStartPeriodType,
              accrualAmount: values.accrualAmount,
              accrualFrequency: values.accrualFrequency,
              accrualFrequencyWeeklyDay: values.accrualFrequencyWeeklyDay,
              accrualFrequencyTwiceAMonthDay1: values.accrualFrequencyTwiceAMonthDay1,
              accrualFrequencyTwiceAMonthDay2: values.accrualFrequencyTwiceAMonthDay2,
              accrualFrequencyMonthlyDay: values.accrualFrequencyMonthlyDay,
              accrualFrequencyTwiceAYearDay1: values.accrualFrequencyTwiceAYearDay1,
              accrualFrequencyTwiceAYearMonth1: values.accrualFrequencyTwiceAYearMonth1,
              accrualFrequencyTwiceAYearDay2: values.accrualFrequencyTwiceAYearDay2,
              accrualFrequencyTwiceAYearMonth2: values.accrualFrequencyTwiceAYearMonth2,
              accrualFrequencyQuarterlyDay1: values.accrualFrequencyQuarterlyDay1,
              accrualFrequencyQuarterlyMonth1: values.accrualFrequencyQuarterlyMonth1,
              accrualFrequencyQuarterlyDay2: values.accrualFrequencyQuarterlyDay2,
              accrualFrequencyQuarterlyMonth2: values.accrualFrequencyQuarterlyMonth2,
              accrualFrequencyQuarterlyDay3: values.accrualFrequencyQuarterlyDay3,
              accrualFrequencyQuarterlyMonth3: values.accrualFrequencyQuarterlyMonth3,
              accrualFrequencyQuarterlyDay4: values.accrualFrequencyQuarterlyDay4,
              accrualFrequencyQuarterlyMonth4: values.accrualFrequencyQuarterlyMonth4,
              accrualFrequencyYearlyDay: values.accrualFrequencyYearlyDay,
              accrualFrequencyYearlyMonth: values.accrualFrequencyYearlyMonth,
              maximumAccrual: values.maximumAccrual,
              carryOverAmount: values.carryOverAmount,
              leaveType: values.leaveType
            })
                .then(res => {
                  console.log(res)
                  form.resetFields();
                  this.setState({ visible: false });
                  this.fetchData()
            })
                .catch(error => console.err(error));
                
        default: return;
      }
    });
  }

  handleEdit = record => {
      this.setState({leavePolicy: record});
      this.showModal('put');
  }

  handleDelete = (record) => {
    const datalist = [...this.state.datalist];

    return axios.delete(`${API_HOST_URL}/api/leave/leavepolicy/${record.id}/`)
                .then(res => {
                  console.log(res)

                  this.setState({ visible: false });
                  this.fetchData()
            })
                .catch(error => console.err(error));
  }

  showModal = (type) => {
    if( type === 'post'){
      //no data should be passed to dialog form
      this.setState({leavePolicy: {}});
    }

    this.setState({ visible: true, requestType: type });
  }

  handleCancel = () => {
    this.setState({ visible: false });
  }

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  }

    render(){
        return(
          <div>
            {
              this.props.userPermissions.indexOf('add_leavepolicy') > -1 ? 
              <Button type="primary" onClick={() => this.showModal('post')}>Add Leave Policy</Button>
              : ''
            }

            {
              this.props.userPermissions.indexOf('view_leavepolicy') > -1 ? 
            <Table columns={this.columns} dataSource={this.state.datalist} rowKey="id" scroll={{ x: '100%' }}/>
            : 'You do not have rights to view Leave Policies. Please Contact your Administrator'
            }

            <LeavePolicyDialogForm
              wrappedComponentRef={this.saveFormRef}
              visible={this.state.visible}
              onCancel={this.handleCancel}
              onCreate={this.handleCreate}
              data={this.state.leavePolicy}/>
        </div>
        );
    }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null,
    userPermissions: state.userPermissions
  }
}

export default connect(mapStateToProps, null)(LeavePolicy);
// export default LeavePolicy;
